import { useMatchMedia } from '../../../hooks/useMatchMedia'

export const useGuidedPurchaseItemSpec = (): 'right' | 'bottom' => {
  const isDesktop = useMatchMedia('(min-width: 768px)')

  return isDesktop ? 'right' : 'bottom'
}
